<script setup lang="ts">
import FooterLinksList from '@/components/Footer/footer-links/FooterLinksList.vue'

const CLIENTS_LINKS = [
  {
    title: 'Акции',
    path: '/sales/',
  },
  {
    title: 'Наши рестораны',
    path: '/delivery/',
  },
  {
    title: 'Бонусы',
    path: '/bonus/',
  },
  {
    title: 'Оплата',
    path: '/payment/',
  },
  {
    title: 'Карта сайта',
    path: '/sitemap/',
  },
]
</script>

<template>
  <footer-links-list :links="CLIENTS_LINKS" />
</template>
